import React, { useState, useRef, useEffect } from 'react';

function InfoButton({ tooltip }) {
  const [showTooltip, setShowTooltip] = useState(false);
  const [isLeaving, setIsLeaving] = useState(false);
  const timeoutRef = useRef(null);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);

  const handleInteractionStart = () => {
    setShowTooltip(true);
    setIsLeaving(false);
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
  };

  const handleInteractionEnd = () => {
    setIsLeaving(true);
    timeoutRef.current = setTimeout(() => {
      setShowTooltip(false);
      setIsLeaving(false);
    }, 1000);
  };

  return (
    <span className="info-button">
      <button
        onMouseEnter={handleInteractionStart}
        onMouseLeave={handleInteractionEnd}
        onTouchStart={handleInteractionStart}
        onTouchEnd={handleInteractionEnd}
        onClick={(e) => e.preventDefault()} // Prevent default click behavior
      >
        i
      </button>
      {showTooltip && (
        <span className={`tooltip ${isLeaving ? 'fade-out' : ''}`}>
          {tooltip}
        </span>
      )}
    </span>
  );
}

export default InfoButton;